var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_2511)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.9997 24.0014C18.6275 24.0014 24.0004 18.6285 24.0004 12.0007C24.0004 5.3729 18.6275 0 11.9997 0C5.37192 0 -0.000976562 5.3729 -0.000976562 12.0007C-0.000976562 18.6285 5.37192 24.0014 11.9997 24.0014Z",
    fill: "#E5EB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08184 13.2369C6.7721 12.937 6.27794 13.2692 6.43703 13.6691C7.32399 15.8851 9.4893 17.4492 12.0221 17.4492C14.5548 17.4492 16.6483 15.9358 17.5606 13.7789C17.7268 13.3861 17.2284 13.0454 16.9215 13.3424C15.1658 15.0446 11.4364 17.4675 7.08184 13.2369Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0981 9.37508C15.4374 10.224 16.2483 10.7731 17.162 10.7731C18.0757 10.7731 18.8599 10.2409 19.2091 9.41591C19.2752 9.25823 19.2231 9.07943 19.0809 8.98228C18.9387 8.88514 18.7543 8.90063 18.6304 9.0203C17.9645 9.66651 16.9114 10.1846 15.6781 8.9851C15.6091 8.91752 15.519 8.88232 15.4289 8.88232C15.3599 8.88232 15.291 8.90203 15.229 8.94427C15.0868 9.0386 15.0333 9.21599 15.0967 9.37508H15.0981Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78807 9.37514C5.12737 10.2241 5.9383 10.7732 6.85201 10.7732C7.76572 10.7732 8.54991 10.241 8.89906 9.41737C8.96664 9.25969 8.91314 9.08089 8.77235 8.98375C8.63015 8.88661 8.44572 8.90209 8.32183 9.02176C7.65591 9.66797 6.60423 10.1861 5.36952 8.98656C5.30054 8.91899 5.21043 8.88379 5.12033 8.88379C5.05134 8.88379 4.98236 8.9035 4.92041 8.94574C4.77822 9.04006 4.72472 9.21745 4.78807 9.37654V9.37514Z",
    fill: "#2A2A2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_2511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.fe34a15cd3fddc8d99a270913b68e452.svg";
export { ForwardRef as ReactComponent };